import React, { useState, useEffect, SetStateAction } from "react";
import { Box, Typography } from "@mui/material";
import { CollectionCreator } from "../../ui/CollectionCreator.tsx";

interface Collection {
  files?: any[];
  [key: string]: any;
}

interface FolderCreatorProps {
  collections: { [key: string]: Collection };
  currentPath: string[];
  newCollectionName: string;
  setNewCollectionName: (name: string) => void;
  collectionNameError: string;
  isDarkMode: boolean;
  disabled?: boolean;
  setCollections: React.Dispatch<React.SetStateAction<any>>;
}

const FolderCreator = ({
  collections,
  currentPath,
  newCollectionName,
  setNewCollectionName,
  collectionNameError,
  isDarkMode,
  disabled = false,
  setCollections
}: FolderCreatorProps) => {

  const [textConfig, setTextConfig] = useState<any>({});

  const fetchTextConfig = async () => {
    try {
      const response = await fetch("/text.json");
      const data = await response.json();
      setTextConfig(data);
    } catch (error) {
      console.error("Error loading text config:", error);
    }
  };

  useEffect(() => {
    fetchTextConfig();
  }, []);

  const handleCreateFolder = () => {
    if (!newCollectionName.trim()) {
      console.error("El nombre de la carpeta es requerido.")
      return;
    }

    if (newCollectionName.length > 50) {
      console.error("El nombre de la carpeta no puede exceder los 50 caracteres.")
      return;
    }

    try {
      // Create a deep clone of the current collections state to ensure immutability
      const updatedCollections = JSON.parse(JSON.stringify(collections));

      let currentLevel = updatedCollections;
      for (const pathPart of currentPath) {
        if (currentLevel[pathPart]) {
          currentLevel = currentLevel[pathPart];
        } else {
          console.error("Invalid currentPath during folder creation.");
          return;
        }
      }

      currentLevel[newCollectionName] = { files: [] };
      setCollections(updatedCollections);
      setNewCollectionName("");

    } catch (error: any) {
      console.error(`Error al crear carpeta: ${error.message}`)
    }
  };

  const isRoot = currentPath.length === 0;
  if (isRoot) {
    return null;
  }

  return (
    <Box
      sx={{
        p: 2,
        mb: 2,
        border: isDarkMode ? "1px solid #2D2D2D" : "1px solid #e5e7eb",
        borderRadius: 2,
        backgroundColor: isDarkMode ? "#27272a" : "#f9fafb",
      }}
    >
      <Typography
        variant="subtitle1"
        fontWeight="bold"
        color={isDarkMode ? "#fff" : "#374151"}
        mb={2}
      >
        {textConfig.FOLDER_CREATOR_TITLE}
      </Typography>

      <CollectionCreator
        isRoot={false}
        value={newCollectionName}
        onChange={setNewCollectionName}
        onCreate={handleCreateFolder}
        error={collectionNameError}
        disabled={disabled}
        isDarkMode={isDarkMode}
        maxLength={50}
        showCharacterCount={true}
      />

      <Typography
        color={isDarkMode ? "#9CA3AF" : "#6B7280"}
        fontSize="12px"
        mt={1}
      >
        {textConfig.FOLDER_CREATOR_DESCRIPTION}
      </Typography>
    </Box>
  );
};

export default FolderCreator;